"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const constants_1 = require("@/constants");
const auth_1 = require("@/helpers/auth");
const selectors_1 = __importDefault(require("@/selectors"));
class PrivateRoute extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { component, user, path, exact } = this.props;
            const authToken = (0, auth_1.getAuth)();
            if (user || authToken) {
                return react_1.default.createElement(react_router_dom_1.Route, { exact: exact, path: path, component: component });
            }
            return react_1.default.createElement(react_router_dom_1.Redirect, { to: constants_1.Routes.Login });
        };
    }
}
PrivateRoute.defaultProps = { exact: false, };
const mapStateToProps = (state) => ({ user: selectors_1.default.user.getUser(state), });
exports.default = (0, react_redux_1.connect)(mapStateToProps)(PrivateRoute);
